module.exports = __webpack_public_path__ + "static/japan06-f7fb9e88167d2805d0c281b88a383b93.jpg";